import { Component, OnInit, ViewChild } from '@angular/core';
import { Utils } from '../utils/utils';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AgenciaService } from '../servicios/agencia.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

@Component({
  selector: 'app-administracion-agencia',
  templateUrl: './administracion-agencia.component.html',
  styleUrls: ['./administracion-agencia.component.css']
})
export class AdministracionAgenciaComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();

  dtOptions: any = {
    pagingType: 'full_numbers',
    scrollX: true,
    dom: 'Bfrtip',
    buttons: [
      'colvis',
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ':visible'
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true }
      }
    ]
  };

  agencias = [];
  haveData = false;
  loading = false;
  timeRunning = 0;
  isEdit = false;
  idDescEdit = '';

  agenciaGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private servicioAgencias: AgenciaService,
    private snackBar: MatSnackBar,
    public ruta: Utils
  ) {

    this.agenciaGroup = this.formBuilder.group({
      formDescripcion: ['', [Validators.required, Validators.maxLength(50)]]
    });

    this.loading = true;
    this.servicioAgencias.getAllAgencia(0)
      .subscribe(result => {

        this.agencias = result;
        console.log(this.agencias);
        this.haveData = true;
        this.loading = false;

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;

      });
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  editar(item) {
    this.idDescEdit = item.id;
    this.agenciaGroup.controls['formDescripcion'].setValue(item.valor);
    this.isEdit = true;
  }

  eliminar(item) {
    const agencia = item.id;
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    const usuario = infoUsuario[0].IdUsuario;


    Swal.fire({
      title: 'Eliminar Agencia?',
      text: 'Esta seguro que desea eliminar esta agencia!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Eliminar!'
    }).then(result => {
      if (result.value) {
        this.servicioAgencias.deleteAgencia(agencia, usuario)
          .subscribe(result => {
            this.agenciaGroup.reset();
            this.isEdit=false;
            this.refrescaBusqueda();
            Swal.fire('Eliminado!', 'Registro Eliminado.', 'success');
          });        
      }
    });




  }

  cancelarEdit() {
    this.agenciaGroup.controls['formDescripcion'].setValue('');
    this.isEdit = false;
  }

  procesoAgencia() {
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    const usuarioConsulta = infoUsuario[0].IdUsuario;
    const descripcion = this.agenciaGroup.controls['formDescripcion'].value;
    const params = {
      descripcion: descripcion,
      usuario: usuarioConsulta
    };
    if (this.isEdit) {//es por que estoy editando 
      this.servicioAgencias.putAgencia(this.idDescEdit, params)
        .subscribe(result => {
          this.refrescaBusqueda();
          this.agenciaGroup.controls['formDescripcion'].setValue('');
          this.isEdit=false;
          this.snackBar.open('Agencia Actualizada', 'Actualizar Agencia', {
            duration: 2000
          });
        });
    }
    else//es por que estoy creando 
    {
      this.servicioAgencias.postAgencia(params)
        .subscribe(result => {
          this.agenciaGroup.controls['formDescripcion'].setValue('');
          this.refrescaBusqueda();
          this.snackBar.open('Agencia Creada', 'Crear Agencia', {
            duration: 2000
          });
        });
    }
  }


  refrescaBusqueda() {
    this.loading = true;
    this.servicioAgencias.getAllAgencia(0)
      .subscribe(result => {

        this.agencias = result;
        console.log(this.agencias);
        this.haveData = true;
        this.loading = false;

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;

      });
  }

}
